export default __webpack_public_path__ + "static/N0237-b430479dca5efdc453eb9d5baa08c6e0.png";